import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {Skill} from "../../projects/domain/skill";
import {Certificate} from "../../projects/domain/certificate";

@Component({
  standalone: false,
  selector: 'app-tooltip',
  template: `
    <ng-container *ngIf="skills.length || certificates.length" xmlns="http://www.w3.org/1999/html">
      <div class="tooltip-container">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-content">
          <ng-container *ngIf="skills.length">
            <div class="mar-bottom">Skills:</div>
            <ng-container *ngFor="let skill of skills">
              <div class="tooltip-item">
                <div class="icon-container">
                  <mat-icon svgIcon="tools" class="item-icon warning-icon"></mat-icon>
                </div>
                <div class="conflict-info">
                  <span class="conflict-title">{{ skill.name }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="certificates.length">
            <div class="mar-bottom mar-top">Certificates:</div>
            <ng-container *ngFor="let certificate of certificates">
              <div class="tooltip-item">
                <div class="icon-container">
                  <mat-icon svgIcon="certificate" class="item-icon warning-icon"></mat-icon>
                </div>
                <div class="conflict-info">
                  <span class="conflict-title">{{ certificate.name }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  `,
  styles: [`
    .tooltip-container {
      position: relative;
      background-color: #F0F0F0;
      border: 1px solid #404B5B;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      min-width: 250px;
      max-width: 350px;
      overflow: hidden;
      z-index: 1000;
    }

    .tooltip-arrow {
      position: absolute;
      top: -8px;
      left: 12px;
      width: 16px;
      height: 8px;
      overflow: hidden;
    }

    .tooltip-arrow:after {
      content: '';
      position: absolute;
      width: 12px;
      height: 12px;
      background: white;
      transform: translateY(50%) rotate(45deg);
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

    .tooltip-content {
      padding: 12px;
    }

    .tooltip-item {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 10px;
    }

    .tooltip-item:last-child {
      margin-bottom: 0;
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      height: 24px;
    }

    .item-icon {
      font-size: 20px;
      height: 25px;
      width: 25px;
      line-height: 20px;
    }

    .conflict-info {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .conflict-title {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      word-wrap: break-word;
    }
    .mar-bottom, .mar-top {
      margin-bottom: 10px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  @Input() skills: Skill[] = [];
  @Input() certificates: Certificate[] = [];
}
